import * as type from "../types";

const makeNewGroup = (id, name) => ({
    grupa_id: id,
    grupa_nazwa: name,
    grupa_opis: null,
    grupa_liczba_aut: 0,
    mnu: false,
    mpp: false,
    mpr: false,
    mprpu: false,
    usuwalna: true,
    przekroczenie_granicy: false,
});

const initialState = {
    groups: [],
    cars: [],
    availableCars: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case type.SET_GROUPS:
            return {
                ...state,
                groups: action.value
            };
        case type.ADD_GROUP:
            return {
                ...state,
                groups: [...state.groups, makeNewGroup(action.id, action.name)]
            };
        case type.SET_GROUP_CARS:
            return {
                ...state,
                cars: action.value
            };
        case type.SET_AVAILABLE_GROUP_CARS:
            return {
                ...state,
                availableCars: action.value
            };
        default:
            return state;
    }
};

